<template>
    <div class="flex items-center gap-3 rounded-xl border border-black/10 p-3">
        <img v-if="product.thumbnail" :src="product.thumbnail" :alt="product.productName" class="size-20 shrink-0 object-contain" />

        <div class="flex min-w-0 flex-col gap-1.5">
            <p class="line-clamp-2 text-sm leading-tight font-bold" v-text="product.productName" />

            <!-- ReviewStars renders a tooltip root, so its text size is set here. -->
            <div v-if="productPageStore.reviewCount" class="text-xs whitespace-nowrap">
                <ReviewStars
                    size="xs"
                    :review-score="productPageStore.reviewScore ?? undefined"
                    :review-count="productPageStore.reviewCount"
                    show-score
                    show-rating
                    show-count-as-label
                />
            </div>

            <div v-if="product.price > 0" class="flex items-center gap-2">
                <span class="rounded-lg bg-prices px-2 py-1 text-sm leading-none font-black text-white" v-text="formatPrice(product.price)" />
                <span
                    v-if="product.recommendedPrice && product.recommendedPrice > product.price"
                    class="text-xs leading-none text-recommended-prices line-through"
                    v-text="formatPrice(product.recommendedPrice)"
                />
                <span v-if="product.discount" class="text-sm leading-none font-bold text-prices">-&nbsp;{{ product.discount }}%</span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import ReviewStars from '@/components/reviews/ReviewStars.vue';
import { useProductWishlistComposable } from '@/composables/products/ProductWishlistComposable';
import { useFormatPrice } from '@/composables/useFormatPrice';
import { useProductPageStore } from '@/stores/pages/ProductPageStore';

const productPageStore = useProductPageStore();
const formatPrice = useFormatPrice();

// Name, thumbnail and price of the selected size, as the wishlist card shows them.
const product = useProductWishlistComposable();
</script>
